import { Component, inject } from '@angular/core';
import {PhotoDownloadService} from '../../services/photo-download.service';
import {of, throwError, timer} from 'rxjs';
import {catchError, filter, map, switchMap, take} from 'rxjs/operators';
import {VwuiModalConfig, VwuiModalRef, VwuiModalService} from '@bvgo-ict/vwui-angular';
import {ProjectReferenceDetailResponse} from '../../models/project-reference-detail.response';
import {BlobDownloadService} from '../../services/blob-download.service';
import {ToastrService} from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import {
    ProjectReferenceDownloadSelectInfoModalComponent
} from '../project-reference-download-select-info-modal/project-reference-download-select-info-modal.component';

@Component({
    selector: 'app-project-reference-download-modal',
    templateUrl: './project-reference-download-modal.component.html',
    standalone: false
})
export class ProjectReferenceDownloadModalComponent {
    private photoDownloadService = inject<PhotoDownloadService>('PhotoDownloadService' as any);
    private blobDownloadService = inject<BlobDownloadService>('BlobDownloadService' as any);
    private toast = inject(ToastrService);
    private modalConfig = inject<VwuiModalConfig<{
    projectReference: ProjectReferenceDetailResponse;
    title: string;
}>>(VwuiModalConfig);
    private modalRef = inject(VwuiModalRef);
    private vwuiModalService = inject(VwuiModalService);

    projectReference: ProjectReferenceDetailResponse;
    downloading = false;

    constructor() {
        const modalConfig = this.modalConfig;

        if (modalConfig.data?.projectReference) {
            this.projectReference = modalConfig.data.projectReference;
        } else {
            throw Error('Property projectReference is missing');
        }
    }

    openPrintModal() {
        this.vwuiModalService.open(ProjectReferenceDownloadSelectInfoModalComponent, {
            modalClass: 'vwui-modal--wide',
            data: {
                projectReference: this.projectReference,
                title: this.modalConfig.data?.title
            }
        })
        this.modalRef.close()
    }

    async download() {
        if (this.downloading) {
            return;
        }

        this.downloading = true

        try {
            const photoDownload = await this.photoDownloadService.enqueue(this.projectReference.id).toPromise();

            const blobUrl = await timer(300, 1000).pipe(
                switchMap(() => {
                    return this.photoDownloadService.detail(photoDownload.fileName).pipe(
                        catchError(error => {
                            if (error instanceof HttpErrorResponse && error.status === 404) {
                                return of({blobUrl: null});
                            } else {
                                return throwError(error);
                            }
                        })
                    )
                }),
                map(it => it.blobUrl),
                filter(it => it !== null),
                take(1)
            ).toPromise();

            await this.blobDownloadService.saveBlob(blobUrl!, `PRS_${this.projectReference.name}_fotos.zip`);

            this.modalRef.close();
        } catch (error) {
            console.error(error);
            this.toast.error('Foto\'s konden niet gedownload worden');
        } finally {
            this.downloading = false;
        }
    }
}
